import * as PIXI from 'pixi.js';
import { Scene } from '../core/Scene';
import { preloadAllSprites } from '../content/SpriteCache';

export class BootScene extends Scene {
  private loadingText!: PIXI.Text;
  private progressBg!: PIXI.Graphics;
  private progressFill!: PIXI.Graphics;

  enter(): void {
    const bounds = this.game.getScreenBounds();

    const title = new PIXI.Text({
      text: 'ХОМЯКИ\nПРОТИВ\nСКАМА',
      style: {
        fill: 0xffd700,
        fontSize: 48,
        fontFamily: 'Arial',
        fontWeight: 'bold',
        align: 'center',
        lineHeight: 60,
      },
    });
    title.anchor.set(0.5);
    title.x = bounds.width / 2;
    title.y = bounds.height * 0.3;
    this.container.addChild(title);

    this.loadingText = new PIXI.Text({
      text: 'Загрузка...',
      style: { fill: 0xffffff, fontSize: 24, fontFamily: 'Arial' },
    });
    this.loadingText.anchor.set(0.5);
    this.loadingText.x = bounds.width / 2;
    this.loadingText.y = bounds.height * 0.55;
    this.container.addChild(this.loadingText);

    this.progressBg = new PIXI.Graphics();
    this.progressBg.roundRect(bounds.width / 2 - 150, bounds.height * 0.6, 300, 20, 10);
    this.progressBg.fill(0x333333);
    this.container.addChild(this.progressBg);

    this.progressFill = new PIXI.Graphics();
    this.progressFill.roundRect(bounds.width / 2 - 150, bounds.height * 0.6, 0, 20, 10);
    this.progressFill.fill(0x4CAF50);
    this.container.addChild(this.progressFill);

    this.loadAssets();
  }

  private async loadAssets(): Promise<void> {
    const bounds = this.game.getScreenBounds();

    this.loadingText.text = 'Загрузка спрайтов...';
    this.progressFill.clear();
    this.progressFill.roundRect(bounds.width / 2 - 150, bounds.height * 0.6, 150, 20, 10);
    this.progressFill.fill(0x4CAF50);

    await preloadAllSprites();

    this.loadingText.text = 'Готово!';
    this.progressFill.clear();
    this.progressFill.roundRect(bounds.width / 2 - 150, bounds.height * 0.6, 300, 20, 10);
    this.progressFill.fill(0x4CAF50);

    await new Promise(r => setTimeout(r, 300));
    this.game.switchScene('menu');
  }

  exit(): void {
    this.container.removeChildren();
  }
}
